module.exports = __webpack_public_path__ + "assets/img/join2021_022.d7227c37.png";